export const zhCnLocale = {
  model: {
    event: '活动'
  },
  event: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    address: '地址',
    title: '标题',
    applicationId: '应用ID',
    endAt: '结束时间',
    startAt: '开始时间',
    eventCategoryId: 'Event category',
    miniProgramPath: '小程序路径',
    eventCategory: '活动分类',
    description: '描述',
    images: '图片',
    application: '应用管理',
  }
}

export const enLocale = {
  model: {
    event: 'Event'
  },
  event: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    address: 'Address',
    title: 'Title',
    applicationId: 'Application',
    endAt: 'End at',
    startAt: 'Start at',
    eventCategoryId: 'Event category',
    miniProgramPath: 'Mini program path',
    eventCategory: 'Event category',
    description: 'Description',
    images: 'Images',
    application: 'Application',
  }
}

